var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.271,
    height: 16,
    viewBox: "0 0 14.271 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#939395;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-4375.6-1458.371l-3.493-4.162-1.981,1.662-6.313-2.3-1.166-6.617,5.146-4.319,6.314,2.3,1.167,6.618-2.023,1.7,3.492,4.162a.746.746,0,0,1-.092,1.051.743.743,0,0,1-.479.174A.743.743,0,0,1-4375.6-1458.371Zm-11.659-10.943.928,5.26,5.019,1.827,4.093-3.433-.929-5.26-5.019-1.827Z",
    transform: "translate(4388.55 1474.105)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.74845b17cdf19a538f8cec27d7695a50.svg";
export { ForwardRef as ReactComponent };